import React, { FC } from 'react';
import { Badge, ConfigProvider, Space, Tooltip, Typography } from 'antd';
import { CategoryTagsFragment } from '../../generated/graphql';

const { Text } = Typography;

type Category = {
  id: string;
  name: string | null;
  backgroundColor?: string;
  color?: string;
}

interface StaticCategoriesInterface {
  categories: Category[];
  hideText?: boolean;
}

export const StaticCategories: FC<StaticCategoriesInterface> = ({ categories, hideText }) => {
  if (categories.length === 0) return null;

  return (
    <ConfigProvider
      theme={{
        components: {
          Badge: {
            dotSize: 8
          }
        }
      }}
    >
      <Space className={'category-badges'} style={{ rowGap: 0, columnGap: '6px', marginRight: 6 }} wrap>
        { categories.map(({ id, name, backgroundColor, color }) => (
          <Tooltip
            key={id}
            title={hideText ? name.toLocaleUpperCase() : ''}
          >
            <Badge
              count={hideText ? '' : null}
              dot
              color={backgroundColor || color}
              className={'category-badge'}
              text={
                hideText ? null :
                <Text ellipsis={{ tooltip: name }} style={{ maxWidth: 165 }} type='secondary'>
                  { name.toLocaleUpperCase() }
                </Text>
              }
              />
          </Tooltip>
        ))}
      </Space>
    </ConfigProvider>
  );
};
